import Vue from 'vue';

export const DATE_RANGE_LAST_4_WEEK = { nombre: 'las últimas 4 semanas', valor: 'ultimas4semanas' };
export const DATE_RANGE_MONTH = { nombre: 'este mes', valor: 'esteMes' };
export const DATE_RANGE_MONTH_AND_PREVIUS = {
  nombre: 'este mes y el anterior',
  valor: 'esteMesConAnterior'
};
export const DATE_RANGE_LAST_3_MONTH = { nombre: 'los últimos 3 meses', valor: 'ultimos3meses' };
export const DATE_RANGE_LAST_6_MONTH = { nombre: 'los últimos 6 meses', valor: 'ultimos6meses' };
export const DATE_RANGE_LAST_9_MONTH = { nombre: 'los últimos 9 meses', valor: 'ultimos9meses' };
export const DATE_RANGE_LAST_12_MONTH = { nombre: 'los últimos 12 meses', valor: 'ultimos12meses' };
export const DATE_RANGE_LAST_YEAR = { nombre: 'el último año', valor: 'ultimoAnio' };
export const DATE_RANGE_LAST_2_YEARS = { nombre: 'los últimos 2 años', valor: 'ultimos2Anios' };
export const DATE_RANGE_PERSONALISED = { nombre: '* Rango personalizado', valor: 'personalizado' };

export const aliasToDate = (valor) => {
  let rangeFrom = null;
  let rangeUntil = null;
  switch (valor) {
    case 'ultimas4semanas':
      rangeFrom = Vue.moment().subtract(28, 'days').format('YYYY-MM-DD');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
    case 'esteMes':
      rangeFrom = Vue.moment().startOf('month').format('YYYY-MM-DD');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
    case 'esteMesConAnterior':
      rangeFrom = Vue.moment().subtract(2, 'month').startOf('month').format('YYYY-MM-DD');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
    case 'ultimos3meses':
      rangeFrom = Vue.moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
    case 'ultimos6meses':
      rangeFrom = Vue.moment().subtract(6, 'month').startOf('month').format('YYYY-MM-DD');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
    case 'ultimos9meses':
      rangeFrom = Vue.moment().subtract(9, 'month').startOf('month').format('YYYY-MM-DD');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
    case 'ultimos12meses':
      // eGestion exige init_date < 1 año antes de end_date, sumamos 1 dia de margen
      rangeFrom = Vue.moment().subtract(1, 'year').add(1, 'day').format('YYYY-MM-DD');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
    case 'ultimoAnio':
      rangeFrom = Vue.moment().subtract(1, 'year').startOf('year');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
    case 'ultimos2Anios':
      rangeFrom = Vue.moment().subtract(2, 'year').startOf('year').format('YYYY-MM-DD');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
    default:
      rangeFrom = Vue.moment().subtract(6, 'month').startOf('month').format('YYYY-MM-DD');
      rangeUntil = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
      break;
  }
  return { rangeFrom, rangeUntil };
};
export const DATE_RANGES = [
  DATE_RANGE_LAST_4_WEEK,
  DATE_RANGE_MONTH,
  DATE_RANGE_MONTH_AND_PREVIUS,
  DATE_RANGE_LAST_3_MONTH,
  DATE_RANGE_LAST_6_MONTH,
  DATE_RANGE_LAST_9_MONTH,
  DATE_RANGE_LAST_12_MONTH,
  DATE_RANGE_LAST_YEAR,
  DATE_RANGE_LAST_2_YEARS,
  DATE_RANGE_PERSONALISED
];

export default {
  DATE_RANGES,
  DATE_RANGE_LAST_4_WEEK,
  DATE_RANGE_MONTH,
  DATE_RANGE_MONTH_AND_PREVIUS,
  DATE_RANGE_LAST_3_MONTH,
  DATE_RANGE_LAST_6_MONTH,
  DATE_RANGE_LAST_9_MONTH,
  DATE_RANGE_LAST_12_MONTH,
  DATE_RANGE_PERSONALISED,
  DATE_RANGE_LAST_YEAR,
  DATE_RANGE_LAST_2_YEARS
};
